<template>
  <div style="clear: both;">
    <template v-if="callResult">
      <v-container>
        <v-row>
          <v-col cols="12">
            <span class="screenHeading">Select Process Managers</span>
          </v-col>
        </v-row>
        <v-form @submit.exact="sendData" @submit.prevent="samePerson == true" autocomplete="off">
          <v-row>
            <v-col cols="12" sm="6">
              <people-picker
                v-model="primaryProcessManager"
                name="primaryProcessManager"
                :user="primaryProcessManager"
                label="Primary"
                @clear="
                  primaryProcessManager = null;
                  checked = true
                "
                @blur="checked = true"
                :checked="checked"
                required
                requiredText="Primary Process Manager is required"
              ></people-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <people-picker
                @clear="backupProcessManager = null"
                v-model="backupProcessManager"
                :user="backupProcessManager"
                label="Backup"
              ></people-picker>
            </v-col>
          </v-row>
          <v-row>
            <span class="error--text" v-if="samePerson">Primary and Backup Process Managers cannot be the same person</span>
          </v-row>

          <v-btn :disabled="!primaryProcessManager || samePerson" color="success" class="me-2" type="submit">Save</v-btn>
          <v-btn color="info" @click="confirm = true">Cancel</v-btn>
        </v-form>
      </v-container>
      <v-dialog persistent v-model="confirm" max-width="500">
        <v-card>
          <v-toolbar color="warning" dense>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>mdi-bell-alert-outline</v-icon>
            </v-btn>            
          </v-toolbar>
          <v-card-text class="text-h5">Confirm cancel</v-card-text>
          <v-card-text>Are you sure you want to cancel your change?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn primary text="text" color="error" @click="cancel()">Yes</v-btn>
            <v-btn text="text" color="info" @click="confirm = false">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import MOCAdminService from '@/services/admin.service'
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
import Toaster from '@/components/Toaster'
export default {
  name: 'ProcessManager',
  data: () => ({
    // people pickers
    primaryProcessManager: null,
    backupProcessManager: null,
    callResult: null,
    valid: false,
    isSaving: false,
    checked: false,
    confirm: false,
    snackbar: {
      show: false,
      color: '',
      mode: '',
      successTimeout: 2000,
      timeout: 6000,
      text: '',
      icon: null,
      closeIcon: 'close'
    }
  }),
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    formData: {}
  },
  methods: {
    cancel() {
      this.getData()
      this.confirm = false
    },
    sendData: function() {
      var data = {}
      var create = true
      if (this.callResult && this.callResult[0]) {
        data = this.callResult[0]
        create = false // update....
      }
      data.processManagerBackup = this.backupProcessManager
      data.processManagerPrimary = this.primaryProcessManager
      this.isSaving = true
      MOCAdminService.setProcessManager(data, create)
        .then(u => {
          this.callResult = u
          this.getData()
          this.$refs.toaster.pop('success', 'Process managers updated')
        })
        .catch(e => {
          // TODO: deterimine if we need to do anything here
          if (e.response.status === 403) {
            this.$refs.toaster.pop('error', 'You are unauthorized to change Process Managers')
          } else {
            this.$refs.toaster.pop('error', 'Error while saving')
          }
        })
        .finally(() => {
          this.isSaving = false
        })
    },
    getData: function() {
      this.errorObject = null
      this.callResult = null
      MOCAdminService.getProcessManager()
        .then(u => {
          this.callResult = u
          if (u && u[0]) {
            this.primaryProcessManager = u[0].processManagerPrimary
            this.backupProcessManager = u[0].processManagerBackup
          }
        })
        .catch(() => {
          // TODO: deterimine if we need to do anything here
          this.$refs.toaster.pop('error', 'Error retrieving process managers')
        })
    }
  },
  components: {
    PeoplePicker,
    Toaster
  },
  computed: {
    samePerson() {
      return (
        this.primaryProcessManager &&
        this.backupProcessManager &&
        this.primaryProcessManager.userPrincipalName === this.backupProcessManager.userPrincipalName
      )
    }
  },
  created() {
    this.getData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
